import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useEffect, useState, useRef } from 'react';
import { createPortal } from 'react-dom';
import Close from 'assets/icons/close.svg';
export default function Modal(t0) {
  const $ = _c(41);
  const {
    isOpen,
    onClose,
    children,
    className: t1,
    ariaLabel: t2,
    modalClass: t3,
    ModalBodyClass: t4,
    useMobileSlide: t5
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const ariaLabel = t2 === undefined ? "Dialog" : t2;
  const modalClass = t3 === undefined ? "" : t3;
  const ModalBodyClass = t4 === undefined ? "" : t4;
  const useMobileSlide = t5 === undefined ? true : t5;
  const [isVisible, setIsVisible] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const modalRef = useRef(null);
  const modalRootRef = useRef(null);
  const closeButtonRef = useRef(null);
  const previousFocusRef = useRef(null);
  const bodyStyleRef = useRef(null);
  const scrollYRef = useRef(0);
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  const backgroundNodesRef = useRef(t6);
  let t7;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      if (!modalRef.current) {
        return [];
      }
      const focusable = modalRef.current.querySelectorAll("a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex=\"-1\"]), [contenteditable=\"true\"]");
      return Array.from(focusable).filter(_temp);
    };
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const getFocusableElements = t7;
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      const focusable_0 = getFocusableElements();
      const target = focusable_0[0] || closeButtonRef.current || modalRef.current;
      if (!target?.focus) {
        return;
      }
      try {
        target.focus({
          preventScroll: true
        });
      } catch {
        target.focus();
      }
    };
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  const focusFirstElement = t8;
  let t10;
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      requestAnimationFrame(() => setIsMounted(true));
    };
    t10 = [];
    $[3] = t10;
    $[4] = t9;
  } else {
    t10 = $[3];
    t9 = $[4];
  }
  useEffect(t9, t10);
  let t11;
  let t12;
  if ($[5] !== isOpen) {
    t11 = () => {
      if (isOpen) {
        const {
          body,
          documentElement
        } = document;
        const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
        scrollYRef.current = window.scrollY || window.pageYOffset || 0;
        bodyStyleRef.current = {
          overflow: body.style.overflow,
          paddingRight: body.style.paddingRight,
          position: body.style.position,
          top: body.style.top,
          width: body.style.width
        };
        body.style.overflow = "hidden";
        body.style.position = "fixed";
        body.style.top = `-${scrollYRef.current}px`;
        body.style.width = "100%";
        body.style.paddingRight = scrollbarWidth > 0 ? `${scrollbarWidth}px` : "";
      }
      return () => {
        const {
          body: body_0,
          documentElement: documentElement_0
        } = document;
        const previous = bodyStyleRef.current || {};
        documentElement_0.style.scrollBehavior = "auto";
        body_0.style.overflow = previous.overflow || "";
        body_0.style.paddingRight = previous.paddingRight || "";
        body_0.style.position = previous.position || "";
        body_0.style.top = previous.top || "";
        body_0.style.width = previous.width || "";
        window.scrollTo(0, scrollYRef.current);
        setTimeout(() => {
          documentElement_0.style.scrollBehavior = "";
        }, 50);
      };
    };
    t12 = [isOpen];
    $[5] = isOpen;
    $[6] = t11;
    $[7] = t12;
  } else {
    t11 = $[6];
    t12 = $[7];
  }
  useEffect(t11, t12);
  let t13;
  let t14;
  if ($[8] !== isOpen) {
    t13 = () => {
      if (isOpen) {
        previousFocusRef.current = document.activeElement;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setIsVisible(true);
          });
        });
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            focusFirstElement();
          });
        });
      } else {
        queueMicrotask(() => {
          setIsVisible(false);
          const previous_0 = previousFocusRef.current;
          if (previous_0 && document.contains(previous_0) && previous_0.focus) {
            try {
              previous_0.focus({
                preventScroll: true
              });
            } catch {
              previous_0.focus();
            }
          }
        });
      }
    };
    t14 = [isOpen];
    $[8] = isOpen;
    $[9] = t13;
    $[10] = t14;
  } else {
    t13 = $[9];
    t14 = $[10];
  }
  useEffect(t13, t14);
  let t15;
  let t16;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => () => {
      if (previousFocusRef.current) {
        previousFocusRef.current?.focus?.();
      }
    };
    t16 = [];
    $[11] = t15;
    $[12] = t16;
  } else {
    t15 = $[11];
    t16 = $[12];
  }
  useEffect(t15, t16);
  let t17;
  let t18;
  if ($[13] !== isOpen || $[14] !== onClose) {
    t17 = () => {
      if (!isOpen) {
        return;
      }
      const handleKeyDown = e => {
        if (e.key === "Escape") {
          e.preventDefault();
          onClose();
          return;
        }
        if (e.key !== "Tab") {
          return;
        }
        const focusable_1 = getFocusableElements();
        if (!focusable_1 || focusable_1.length === 0) {
          return;
        }
        const first = focusable_1[0];
        const last = focusable_1[focusable_1.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else {
          if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      };
      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
    };
    t18 = [isOpen, onClose];
    $[13] = isOpen;
    $[14] = onClose;
    $[15] = t17;
    $[16] = t18;
  } else {
    t17 = $[15];
    t18 = $[16];
  }
  useEffect(t17, t18);
  let t19;
  let t20;
  if ($[17] !== isOpen) {
    t19 = () => {
      if (!isOpen) {
        return;
      }
      const handleFocusIn = e_0 => {
        if (!modalRef.current) {
          return;
        }
        if (modalRef.current.contains(e_0.target)) {
          return;
        }
        focusFirstElement();
      };
      document.addEventListener("focusin", handleFocusIn);
      return () => document.removeEventListener("focusin", handleFocusIn);
    };
    t20 = [isOpen];
    $[17] = isOpen;
    $[18] = t19;
    $[19] = t20;
  } else {
    t19 = $[18];
    t20 = $[19];
  }
  useEffect(t19, t20);
  let t21;
  let t22;
  if ($[20] !== isOpen) {
    t21 = () => {
      if (!isOpen) {
        return;
      }
      const modalRoot = modalRootRef.current;
      if (!modalRoot) {
        return;
      }
      const bodyChildren = Array.from(document.body.children);
      const modified = [];
      bodyChildren.forEach(child => {
        if (child === modalRoot) {
          return;
        }
        const previous_1 = {
          element: child,
          ariaHidden: child.getAttribute("aria-hidden"),
          inert: child.inert
        };
        modified.push(previous_1);
        child.setAttribute("aria-hidden", "true");
        if ("inert" in child) {
          child.inert = true;
        } else {
          child.setAttribute("inert", "");
        }
      });
      backgroundNodesRef.current = modified;
      return () => {
        backgroundNodesRef.current.forEach(_temp2);
        backgroundNodesRef.current = [];
      };
    };
    t22 = [isOpen];
    $[20] = isOpen;
    $[21] = t21;
    $[22] = t22;
  } else {
    t21 = $[21];
    t22 = $[22];
  }
  useEffect(t21, t22);
  if (!isOpen || !isMounted) {
    return null;
  }
  const t23 = `fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex md:items-center md:justify-center items-end ${modalClass}`;
  let t24;
  if ($[23] !== onClose) {
    t24 = e_1 => {
      if (e_1.target === e_1.currentTarget) {
        onClose();
      }
    };
    $[23] = onClose;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      overscrollBehavior: "contain"
    };
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  const t26 = ` relative w-full md:max-w-[30em] bg-white shadow-xl p-4 pr-0 md:p-6 md:pr-0 rounded-t-2xl md:rounded-2xl mx-auto
                    transition-all duration-300 ease-out md:transition-none md:translate-y-0 md:opacity-100
                    ${useMobileSlide ? isVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0" : "opacity-100"} 
                    ${className}
        `;
  let t27;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Image src={Close} alt="close icon" width={14} height={14} className="w-3 h-3" />;
    $[26] = t27;
  } else {
    t27 = $[26];
  }
  let t28;
  if ($[27] !== onClose) {
    t28 = <button type="button" ref={closeButtonRef} onClick={onClose} aria-label="Close modal" className="absolute w-9 h-9 z-20 rounded-full flex items-center justify-center lg:top-3 lg:right-3 top-2 right-2 bg-[#00EAFD] cursor-pointer">{t27}</button>;
    $[27] = onClose;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  const t29 = `max-h-[90vh] max-h-[90dvh] overflow-y-auto md:pr-6 pr-4 ${ModalBodyClass}`;
  let t30;
  if ($[29] !== children || $[30] !== t29) {
    t30 = <div className={t29}>{children}</div>;
    $[29] = children;
    $[30] = t29;
    $[31] = t30;
  } else {
    t30 = $[31];
  }
  let t31;
  if ($[32] !== t26 || $[33] !== t28 || $[34] !== t30) {
    t31 = <div onClick={_temp3} tabIndex={-1} ref={modalRef} style={t25} className={t26}>{t28}{t30}</div>;
    $[32] = t26;
    $[33] = t28;
    $[34] = t30;
    $[35] = t31;
  } else {
    t31 = $[35];
  }
  let t32;
  if ($[36] !== ariaLabel || $[37] !== t23 || $[38] !== t24 || $[39] !== t31) {
    const modalContent = <div className={t23} onClick={t24} role="dialog" aria-modal="true" aria-label={ariaLabel} ref={modalRootRef}>{t31}</div>;
    t32 = createPortal(modalContent, document.body);
    $[36] = ariaLabel;
    $[37] = t23;
    $[38] = t24;
    $[39] = t31;
    $[40] = t32;
  } else {
    t32 = $[40];
  }
  return t32;
}
function _temp3(e_2) {
  return e_2.stopPropagation();
}
function _temp2(t0) {
  const {
    element,
    ariaHidden,
    inert
  } = t0;
  if (ariaHidden === null) {
    element.removeAttribute("aria-hidden");
  } else {
    element.setAttribute("aria-hidden", ariaHidden);
  }
  if ("inert" in element) {
    element.inert = inert;
  } else {
    element.removeAttribute("inert");
  }
}
function _temp(el) {
  return el.tabIndex !== -1 && !el.hasAttribute("disabled");
}